import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useSyncExternalStore } from 'react';
import BrandKitItem from './BrandKitItem';
import BrandKitMigrationBanner from './BrandKitMigrationBanner';
import BrandKitSkeleton from './BrandKitSkeleton';
import { BRAND_KIT_DEFAULT_CONFIGURATION } from './constants';
import { loadBrandKitAndVoiceProfile } from '@/stores/brandKit';
import { showErrorToast } from '@/libs/toast/toast';
import Icon from '@/components/atoms/Icon';
import { FeatureFlagKeys } from '@/services/featureFlag';
import featureFlagStore from '@/stores/featureFlagStore';

export default function BrandKit(): JSX.Element {
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot);
  const isCLHomePageEnabled = featureFlags[FeatureFlagKeys.Use_CL_New_HomePage];

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
  };

  const { isFetching: isLoading } = useQuery({
    queryKey: 'brand-kit',
    queryFn: () => loadBrandKitAndVoiceProfile(),
    onError: () =>
      showErrorToast(
        "Just a heads up, we're having a bit of trouble loading your brand kit data. Give it another moment, then try refreshing."
      )
  });

  return (
    <div className="min-h-[calc(100vh-4.25rem)] grow overflow-hidden bg-slate-50">
      <div className="flex w-full items-center justify-between pl-7 pr-4 pt-6">
        {!isCLHomePageEnabled ? (
          <h3 className="text-xl font-medium tracking-tight text-black lg:text-2xl">Brand Kit</h3>
        ) : (
          <div className="flex items-center gap-2 text-slate-950">
            <div className="cursor-pointer" onClick={handleGoBack}>
              <Icon name="IconChevronLeft" size={24} />
            </div>
            <div className="text-xl font-medium tracking-tight">Brand Kit</div>
          </div>
        )}
      </div>
      <BrandKitMigrationBanner />
      <div className="mt-4 space-y-4 pb-8 pl-7 pr-4">
        {isLoading ? (
          <BrandKitSkeleton />
        ) : (
          Object.keys(BRAND_KIT_DEFAULT_CONFIGURATION).map(key => {
            return <BrandKitItem configurationItem={BRAND_KIT_DEFAULT_CONFIGURATION[key]} key={key} />;
          })
        )}
      </div>
    </div>
  );
}
